export enum GrantRule {
  AdHoc = 'ad-hoc',
  PerRequest = 'per-request',
  OncePerWeekFriday = 'once-per-week-friday',
  PerRequestWikiEntry = 'per-reuqest-wiki-entry',
  KudosBased = 'kudos-based',
  PerRequestFeedbackReceiver = 'per-request-feedback-receiver',
  PerWikiEntry = 'per-wiki-entry',
  PerRequestReviewed = 'per-request-reviewed',
  AfterTraining = 'after-training',
  AfterPizzaMeeting = 'after-pizza-meeting',
  AfterPostPublished = 'after-post-published',
  AfterExternalTraining = 'after-external-training',
  AfterTest = 'after-test',
  EndOfMonth = 'end-of-month',
  AfterMeeting = 'after-meeting',
  AfterEvent = 'after-event',
}

export const grantRuleMap = {
  'swimming-progress': GrantRule.AfterTest,
  'promo-club': GrantRule.AdHoc,
  'running-participation': GrantRule.EndOfMonth,
  'grouping': GrantRule.AfterMeeting,
  'positive-behaviour': GrantRule.AdHoc,
  'cycling-progress': GrantRule.AfterTest,
  'competition-ssm': GrantRule.AfterEvent,
  'running-test': GrantRule.AfterTest,
  'bicycle-condition': GrantRule.AfterTraining,
  'cycling-participation': GrantRule.EndOfMonth,
  'condition': GrantRule.AfterTraining,
  'integration': GrantRule.AfterEvent,
  'running-progress': GrantRule.AfterTest,
  'swimming-competition': GrantRule.AfterEvent,
  'running-competition': GrantRule.AfterEvent,
  'swimming-test': GrantRule.AfterTest,
  'multisport-competition': GrantRule.AfterEvent,
  'swimming-participation': GrantRule.EndOfMonth,
  'cycling-competition': GrantRule.AfterEvent,
  'parkrun': GrantRule.AfterEvent,
  'cycling-test': GrantRule.AfterTest,
};
